import { getLocaleUTCDateTimeString } from '@go-shared/lib/time';
import React, { FC } from 'react';
import { VenueRequestComment } from '../../shared/types/groupBooking';

export type GroupMessagePosition = 'left' | 'right';

export interface GroupMessageProps {
  comment: VenueRequestComment;
  position: GroupMessagePosition;
  dark?: boolean;
}

function getSenderInitials(comment: VenueRequestComment) {
  return [comment.user.firstName, comment.user.lastName]
    .map(s => s.trim())
    .filter(s => s.length > 0)
    .map(s => s[0].toUpperCase())
    .join('');
}

const GroupMessage: FC<GroupMessageProps> = ({ comment, dark, position }) => {
  let addtClass = '';

  if (dark) {
    addtClass = 'bg-slate text-white';
  } else {
    addtClass = 'bg-white';
  }

  switch (comment.status) {
    case 'approved':
      addtClass = 'bg-lime-darker text-white';
      break;
    case 'rejected':
    case 'cancelled':
      addtClass = 'bg-crimson text-white';
      break;
    case 'draft':
      addtClass = 'bg-banana-dark text-white';
      break;
  }

  return (
    <div className="p-2 flex flex-col w-full">
      <div
        className={`flex relative p-2 rounded shadow
    ${position === 'right' ? 'self-end' : 'self-start'} ${addtClass}`}
        style={{ width: '80%' }}
      >
        {position === 'left' && (
          <div
            className="bg-white grid w-8 h-8 text-md mr-2 rounded-full
        items-center justify-center text-navy-darkest border shadow flex-shrink-0"
          >
            {getSenderInitials(comment)}
          </div>
        )}

        <div className="flex-grow">
          <div>{comment.message}</div>
          <span className="text-xxs">
            Sent: {getLocaleUTCDateTimeString(comment.date)} by{' '}
            <strong>
              {comment.user.firstName} {comment.user.lastName}
            </strong>
          </span>
        </div>
      </div>
    </div>
  );
};

export default GroupMessage;
